var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row header" }, [
    _c("div", { staticClass: "col d-flex align-items-center mb-2" }, [
      _c("div", { staticClass: "my-auto pr-3" }, [
        _c(
          "a",
          {
            staticClass: "title clickable text-primary",
            attrs: { id: "back-button" },
            on: { click: _vm.goBack },
          },
          [_vm._m(0)]
        ),
      ]),
      _vm._v(" "),
      _c(
        "h2",
        {
          staticClass:
            "header-title mb-0 d-flex align-items-center justify-content-start",
        },
        [
          _c("span", { staticClass: "client-name-header" }, [
            _vm._v("\n        " + _vm._s(_vm.listTitle) + "\n      "),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-3 my-auto forward" }, [
      _c("div", { staticClass: "d-flex client justify-content-end" }, [
        _c(
          "div",
          { staticClass: "p-0 d-none d-lg-flex button-wrapper" },
          [
            _vm.creating
              ? _c(
                  "simple-button",
                  {
                    staticClass: "float-right p-sm-0",
                    attrs: {
                      "class-name": "btn-sm",
                      loading: _vm.creatingList.loading,
                      disabled: _vm.validator.$invalid,
                      "loading-succeeded": _vm.creatingList.status,
                    },
                    on: { click: _vm.handleSubmit },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("lists.createList")) +
                        "\n        "
                    ),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "edit-actions d-flex flex-row" },
                  [
                    _c(
                      "simple-button",
                      {
                        staticClass: "p-sm-0 mr-2",
                        attrs: {
                          "class-name": "btn-sm",
                          disabled: _vm.validator.$invalid,
                          loading: _vm.updatingList.loading,
                          "loading-succeeded": _vm.updatingList.status,
                        },
                        on: { click: _vm.handleSubmit },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("lists.updateList")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "inline-prompt",
                      {
                        ref: "prompt",
                        staticClass: "bold text-gray clickable",
                        attrs: { "action-type": "delete" },
                        on: { accept: _vm.handleDeleteList },
                        scopedSlots: _vm._u([
                          {
                            key: "preConfirmationContent",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "text-gray mb-2" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("lists.removeListConfirmation")
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "simple-button",
                          {
                            attrs: {
                              type: "button",
                              "class-name": "btn btn-danger btn-sm",
                              loading: _vm.deletingList.loading,
                              "loading-succeeded": _vm.deletingList.status,
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("lists.deleteList")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dropleft" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-menu" }, [
            _vm.creating
              ? _c("div", { staticClass: "dropdown-item clickable wide" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn submit-changes move-on add-list",
                      attrs: { type: "submit", form: "list-details-form" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("lists.createList")) +
                          "\n            "
                      ),
                    ]
                  ),
                ])
              : _c("div", { staticClass: "dropdown-item clickable wide" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn submit-changes move-on edit-list",
                      attrs: { type: "submit", form: "list-details-form" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("lists.updateList")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dropdown-item clickable wide" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn text-danger",
                    attrs: { type: "button" },
                    on: { click: _vm.showConfirmDeleteModal },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("lists.deleteList")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("confirm-delete-list-modal", {
                  ref: "confirmDeleteListModal",
                  attrs: { "deleting-list": _vm.deletingList },
                  on: { "delete-list": _vm.handleDeleteList },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c(
        "i",
        {
          staticClass: "material-icons",
          staticStyle: { "font-size": "1.2em", "padding-top": "0.4em" },
        },
        [_vm._v("arrow_back")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "grey-text text-darken-4 clickable d-lg-none",
        attrs: { "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }